import React from 'react';
import { sortBy, map, compose, reduce } from 'lodash/fp';
import FiltersComponent from '../../../../ui-kit/FilterComponent/FiltersComponent';
import { FilterOptionsViewProps } from './types';
import { Options } from '../../../../components/forms/fields/types';
import { mapOptions, getFullName } from '../../../../utils';
import { Employee, Section } from '../../../../server-types';
import { DefaultFormFields } from '../../../../ui-kit/FilterComponent/types';

const FilterView = <T extends DefaultFormFields, >(
    { sections, employees, handleChange, setFormData, formData, children }: FilterOptionsViewProps<T>
) => {
    const placesOptions = compose(
        sortBy<Options>(
            [
                ({ name }) => name.split(' ')[0],
                ({ name })=> parseInt(name.split(' ')[1], 10) || 0,
            ]
        ),
        reduce<Section, Array<Options>>((acc, { places }) => [...acc, ...mapOptions(places)], [])
    )(sections);

    const openedByOptions = compose(
        sortBy<Options>(['name', 'desc']),
        map<Employee, Options>(employee => ({ id: employee.id, name: getFullName(employee.account) }))
    )(employees);

    const options = {
        openedByOptions,
        placesOptions,
    };

    return (
        <FiltersComponent
            options={options}
            formData={formData}
            handleChange={handleChange}
            setFormData={setFormData}
        >
            {children}
        </FiltersComponent>
    );
};

export default FilterView;
